import React from 'react';
import PropTypes from 'prop-types';

const ArticleFooterCard = ({
  imageUrl, name, position, email,
}) => (
  <div className="flex items-center space-x-4">
    {imageUrl ? (
      <img
        src={imageUrl}
        className="w-118px h-118px rounded-full object-cover"
        alt="author"
      />
    ) : (<div className="h-118px w-118px rounded-full bg-orange" />)}
    <div>
      <h1 className="text-24px font-trirong dark:text-white capitalize">{name}</h1>
      <h1 className="text-10px uppercase dark:text-altgrey">{position}</h1>
      <a href="a" className="block pt-2 text-xs text-blue-600 dark:text-orange">{email}</a>
    </div>
  </div>
);

export default ArticleFooterCard;
ArticleFooterCard.propTypes = {
  name: PropTypes.string,
  position: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  imageUrl: PropTypes.string,
  email: PropTypes.string,
};

ArticleFooterCard.defaultProps = {
  name: 'Tobi Michael',
  position: 'Global Head of Legals LP&Co.',
  email: 'mail@lawrencepriceltd.com',
};
